import React from 'react';
import ReactDOM from 'react-dom';
import './Style/index.css';
import App from './Components/App';

ReactDOM.render(<App />, document.getElementById('root'));

